import helpers from "@/common/utils/helpers";
export default [
    { key: "detalhamento", label:"Detalhamento"},
    { key: "justificativa", label: "Justificativa", },
    { key: "valor", label: "Custo",
        formatter: (value) => {
            if (value) return helpers.formatarValor(value);
        },
    },
    { key: "actions", label: "Ações"}
]